import React, { Component } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import './Loading.scss'

class LoadingSpinner extends Component {
  render() {
    return (
      <div>
        <div className="sidebar-placeholder"></div>
        <div className="loading-platform-overlay">
          <LoadingOutlined />
        </div>
      </div>
    )
  }
}

export default LoadingSpinner
